export const PERMISSION_KEYS = [
  'can_create_projects',
  'can_edit_projects',
  'can_delete_projects',
  'can_manage_wypis',
  'can_manage_plot_config',
  'can_export_projects',
  'can_import_projects',
  'can_publish_project',
  'can_manage_layers',
  'can_edit_attributes',
  'can_manage_styles',
  'can_manage_groups',
  'can_manage_app_versions',
  'can_manage_emuia_config',
  'can_publish_geoserver',
  'can_manage_consultations',
  'can_manage_metadata',
  'can_manage_municipality_settings',
] as const;

export type PermissionKey = (typeof PERMISSION_KEYS)[number];

export type Permissions = Record<PermissionKey, boolean>;

export const EMPTY_PERMISSIONS: Permissions = PERMISSION_KEYS.reduce(
  (acc, key) => ({ ...acc, [key]: false }),
  {} as Permissions,
);

export const FULL_PERMISSIONS: Permissions = PERMISSION_KEYS.reduce(
  (acc, key) => ({ ...acc, [key]: true }),
  {} as Permissions,
);

export const PERMISSION_GROUPS: { key: string; keys: PermissionKey[] }[] = [
  {
    key: 'projects',
    keys: [
      'can_create_projects',
      'can_edit_projects',
      'can_delete_projects',
      'can_publish_project',
      'can_export_projects',
      'can_import_projects',
    ],
  },
  {
    key: 'layers',
    keys: [
      'can_manage_layers',
      'can_edit_attributes',
      'can_manage_styles',
      'can_manage_groups',
    ],
  },
  {
    key: 'planning',
    keys: [
      'can_manage_wypis',
      'can_manage_plot_config',
      'can_manage_emuia_config',
      'can_manage_consultations',
    ],
  },
  {
    key: 'advanced',
    keys: [
      'can_publish_geoserver',
      'can_manage_app_versions',
      'can_manage_metadata',
      'can_manage_municipality_settings',
    ],
  },
];
